import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@i18n/i18n";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@store";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={"/membership"}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
